<template>
  <div class="dashboard">
    <div class="contain" v-if="user">
      <p class="hello">Hello {{ user.full_name }},</p>
      <h1>Let's get you registered!</h1>

      <div class="inputs">
        <div class="input full">
          <label>Email Address</label>
          <input v-model="user.email" />
        </div>
        <div class="input full">
          <label>Password</label>
          <input type="password" v-model="password" />
        </div>
        <div class="input full">
          <label>Confirm Password</label>
          <input type="password" v-model="confirm_password" />
        </div>

        <div class="btns">
          <button v-if="status == 'ready'" @click="register()" class="btn">Register</button>
          <img v-if="status == 'loading'" class="loader" src="@/assets/img/loader.gif" />
        </div>

        <p class="errors">{{ this.error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions, auth } from "@/config/firebaseInit";
import firebase from "firebase";

export default {
  name: "register",
  data() {
    return {
      user: null,
      password: null,
      confirm_password: null,
      error: "",
      status: "ready"
    };
  },
  firestore() {
    return {
      user: db.collection("user").doc(this.$route.params.user_id)
    };
  },
  created() {},
  updated() {},
  methods: {
    register() {
      this.status = "loading";
      let vm = this;
      this.error = "";
      if (this.password) {
        if (
          this.password.length >= 6 &&
          this.password == this.confirm_password
        ) {
          firebase
            .auth()
            .createUserWithEmailAndPassword(this.user.email, this.password)
            .then(data => {
              setTimeout(() => {
                vm.saveUid(data.user.uid);
              }, 300);
            })
            .catch(function(error) {
              console.log(error);
              vm.error = error.message;
              vm.status = "ready";
            });
        } else {
          this.status = "ready";
          if (this.password == this.confirm_password) {
            this.error = "Please enter a password with at least 6 characters!";
          } else {
            this.error = "Please make sure both passwords match!";
          }
        }
      } else {
        this.status = "ready";
        this.error = "Please make sure both passwords match!";
      }
    },
    saveUid(uid) {
      this.user.uid = uid;
      let user = this.user;
      let id = this.$route.params.user_id;
      db.collection("user")
        .doc(this.$route.params.user_id)
        .set(this.user)
        .then(() => {
          this.$store.commit("setNewUser", user);
          this.$store.commit("setApplicationApprovalPhase", user.status);
          this.goTo("/dashboard");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.dashboard {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  .hello {
    margin-bottom: 10px;
  }
  .contain {
    max-width: 650px;
    .inputs {
      margin-top: 50px;
    }
    .disabled {
      input {
        background: transparent !important;
        padding: 0;
        border: none;
      }
    }
    .errors {
      margin-top: 20px;
    }
  }
}

.loader {
  height: 60px;
}
</style>
